module.exports = __webpack_public_path__ + "static/media/recommendation4.67fe6b8a.jpg";